// Reminders and AI Insights count what the associate completed, not what was due.
export function getRowTotal({
  chatMessagesLength,
  remindersCompleted,
  clientActivitiesLength,
  newClientsLength,
  salesOppsLength,
  aiInsightsCompleted,
  appointmentsLength = 0,
}) {
  return (
    chatMessagesLength +
    remindersCompleted +
    clientActivitiesLength +
    newClientsLength +
    salesOppsLength +
    aiInsightsCompleted +
    appointmentsLength
  );
}
